"use client"

import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material"
import * as React from "react"
import { ThemeProvider as StyledThemeProvider } from "styled-components"

import GlobalStyle from "./GlobalStyle"
import theme from "./theme"

/**
 * Theme providers for MUI and styled-components.
 * Note: Emotion cache is now handled by AppRouterCacheProvider in layout.tsx
 * for proper SSR support with Next.js App Router.
 */
const ThemeProviders = ({ children }: { children: React.ReactNode }) => (
  <MuiThemeProvider theme={theme}>
    <StyledThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  </MuiThemeProvider>
)

export default ThemeProviders
